import React from "react";
import clsx from "clsx";

/** MUI */
import makeStyles from "@mui/styles/makeStyles";
import { alpha } from "@mui/material/styles";
import { CircularProgress, Skeleton } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        "& > * + *": {
            marginLeft: theme.spacing(2),
        },
    },
    progressColorPrimary: {
        color: alpha(theme.palette.primary.main, 0.2),
    },
    skeletonRoot: {
        minWidth: 200,
        width: "99%",
        backgroundColor: alpha(theme.palette.primary.main, 0.2),
    },
    skeletonWhite: {
        minWidth: 200,
        width: "99%",
        backgroundColor: alpha('#FFF', 0.52),
    },
    skeletonWrap: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1
    },
    circleWrap: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200,
    },
}));

const Preloader = ({ size, thickness, small, type, linesCount = 4, style, white=false }) => {
    const classes = useStyles();

    return (
        <div className={classes.root} style={style}>
            {type === "linear" ? (
                <div className={classes.skeletonWrap}>
                    <Skeleton variant="text" height={20} classes={{ root: clsx(classes.skeletonRoot, white && classes.skeletonWhite) }} />
                    {!!small || (
                        <>
                            {Array(linesCount)
                                .fill()
                                .map((_, i) => (
                                    <Skeleton
                                        variant="text"
                                        height={10}
                                        classes={{ root: clsx(classes.skeletonRoot, white && classes.skeletonWhite) }}
                                        key={i}
                                    />
                                ))}
                        </>
                    )}
                </div>
            ) : (
                <div className={classes.circleWrap}>
                    <CircularProgress
                        size={size || 72}
                        thickness={thickness || 4}
                        color="primary"
                        classes={{ colorPrimary: classes.progressColorPrimary }}
                    />
                </div>
            )}
        </div>
    );
};

export default Preloader;
